module.exports = __webpack_public_path__ + "static/media/arrow-left-grey.02d332a0.svg";